import React, { PropsWithChildren } from 'react';
import { DialogBody, DialogStyled, DialogTitle } from '../dialog/index.styled';
import { TDialogConfirm } from './index.types';
import Button from 'components/control/button/button';
import {
    EButtonSize,
    EButtonType,
} from 'components/control/button/button.types';
import { DialogBodyContent, DialogBodyControlButtons } from './index.styled';

const DialogConfirm = <T,>({
    setIsDialogOpen,
    isDialogOpen,
    title,
    onOk,
    onCancel,
    labels,
    children,
}: PropsWithChildren<TDialogConfirm<T>>) => {
    return (
        <DialogStyled
            onClose={() => setIsDialogOpen(false)}
            aria-labelledby="dialog-delete-confirm"
            open={isDialogOpen}
        >
            <DialogTitle>{title}</DialogTitle>
            <DialogBody>
                {children && <DialogBodyContent>{children}</DialogBodyContent>}
                <DialogBodyControlButtons>
                    <Button
                        size={EButtonSize.Small}
                        onClick={() => {
                            onOk && onOk();
                            setIsDialogOpen(false);
                        }}
                        styleType={EButtonType.Danger}
                    >
                        {labels?.onOk ?? 'OK'}
                    </Button>
                    <Button
                        size={EButtonSize.Small}
                        onClick={() => {
                            onCancel && onCancel();
                            setIsDialogOpen(false);
                        }}
                        styleType={EButtonType.Outline}
                    >
                        {labels?.onCancel ?? 'Cancel'}
                    </Button>
                </DialogBodyControlButtons>
            </DialogBody>
        </DialogStyled>
    );
};

export default DialogConfirm;
